module.exports = __webpack_public_path__ + "img/gambar.086c8c1a.png";